import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Footer } from '@/models/cms';
import { FooterMode } from '@/store/ui';

@Component({
  name: 'CmgFooter',
})
export default class CmgFooter extends Vue {
  @Prop({ type: String })
  mode?: FooterMode;

  countryProfileWatcher?: () => void;
  footer: Footer | null = null;

  mounted() {
    this.countryProfileWatcher = this.$appStore.watch(state => state.ui.countryProfile.countryCode, this.getFooter);
    this.getFooter();
  }

  destroyed() {
    if (this.countryProfileWatcher) {
      this.countryProfileWatcher();
    }
  }

  getFooter() {
    const countryCode = this.$appStore.state.ui.countryProfile.countryCode.toLowerCase();
    this.$services.cms.getFooter(countryCode).then((footer) => {
      this.footer = footer;
    });
  }

  get resolvedMode(): FooterMode {
    return this.mode || this.$appStore.state.ui.footer.options.mode;
  }

  get copyrightText(): string {
    return `© ${new Date().getFullYear()} Chipotle Mexican Grill`;
  }
}
